import styled, {
  css,
  system,
  SystemProps,
  themeGetter,
} from 'quickstart/styled-components/system'

interface DividerProps {
  $divided: boolean | string
  $startCapped: boolean | string
  $endCapped: boolean | string
  $row: boolean
  $first: boolean
  $last: boolean
}

export const Divider = styled.hr.attrs({'aria-hidden': 'true'})<DividerProps>(
  ({$divided, $startCapped, $endCapped, $row, $first, $last, theme}) => {
    const th = themeGetter(theme)
    const dividerStyleKey =
      $first ? $startCapped
      : $last ? $endCapped
      : $divided
    const dividerStyle = th(
      `borders.${dividerStyleKey === true ? 'fine' : dividerStyleKey}`,
      dividerStyleKey,
    )
    return $row ?
        css`
          /* Do not set height:100% here because it results in 0.6667px.
           * The default of align-items:stretch in a flex container has the
           * desired result.
           */
          width: 0;
          border-left: ${dividerStyle};
          margin: 0;
        `
      : css`
          width: 100%;
          height: 0;
          border-top: ${dividerStyle};
          margin: 0;
        `
  },
)

interface StackProps {
  $divided: boolean | string
  $endCapped: boolean | string
  $row: boolean
  $spacing: any
  $startCapped: boolean | string
  $trimMargin: boolean
  $wrapChildren: boolean
}

export const Stack = styled.div<StackProps & SystemProps>(
  ({
    $row,
    $startCapped,
    $endCapped,
    $divided,
    $spacing,
    $trimMargin,
    $wrapChildren,
    theme,
  }) => {
    const th = themeGetter(theme)
    const [paddingBefore, paddingAfter] =
      $row ?
        ['padding-left', 'padding-right']
      : ['padding-top', 'padding-bottom']
    const padding = $spacing && th(`space.${$spacing}`, $spacing)

    // prettier-ignore
    return css`
      display: flex;
      flex-direction: ${$row ? 'row' : 'column'};

      ${$trimMargin && css`
        && > *:first-child ${$wrapChildren ? '> *:first-child' : ''} {
          ${$row ? {marginLeft: '0px'} : {marginTop: '0px'}};
        }
        && > *:last-child ${$wrapChildren ? '> *:last-child' : ''} {
          ${$row ? {marginRight: '0px'} : {marginBottom: '0px'}};
        }
      `};

      ${padding && css`
        && > *:not(${Divider}) {
          ${paddingBefore}: ${padding};
          ${paddingAfter}: ${$divided ? padding : 0};
          &:last-child {
            ${paddingAfter}: 0;
          }
          ${!$startCapped && css`
            &:first-child:not(style),
            &:first-child:is(style) + * {
              ${paddingBefore}: 0;
            }
          `}
          ${$endCapped && !$divided && css`
            &:nth-last-child(2) {
              ${paddingAfter}: ${padding};
            }
          `}
        }
      `};

      ${system};
    `
  },
)

export const Item = styled.div``
